import { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  onClose: () => void;
  url: string;
  name: string;
  subtitle?: string;
}

export function DocViewerModal({ onClose, url, name, subtitle }: Props) {
  useEffect(() => {
    function onKey(e: KeyboardEvent) { if (e.key === 'Escape') onClose(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const isPdf = url.toLowerCase().endsWith('.pdf');
  const isImage = /\.(png|jpe?g|gif|webp)$/i.test(url);

  return createPortal(
    <div className="mo open" onClick={onClose}>
      <div className="modal" style={{ width: 700, maxHeight: '92vh' }} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 14 }}>
          <div>
            <div className="modal-title" id="dv-title">📄 {name}</div>
            {subtitle ? <div className="modal-sub" id="dv-sub">{subtitle}</div> : null}
          </div>
          <button className="close-btn" onClick={onClose} style={{ fontSize: 22 }}>×</button>
        </div>
        <div id="dv-body" style={{ minHeight: 300, maxHeight: '70vh', overflow: 'auto', background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 14 }}>
          {isPdf ? (
            <iframe src={url} style={{ width: '100%', height: '60vh', border: 'none', borderRadius: 6 }} title={name} />
          ) : isImage ? (
            <img src={url} alt={name} style={{ maxWidth: '100%', borderRadius: 6 }} />
          ) : (
            <a href={url} target="_blank" rel="noreferrer" style={{ color: 'var(--info)' }}>Open {name} in new tab</a>
          )}
        </div>
        <div className="modal-actions" id="dv-actions">
          <a className="btn btn-ghost btn-sm" href={url} target="_blank" rel="noreferrer">⬇ Download</a>
          <button className="btn btn-ghost" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
